import React from 'react';

import Cabecalho from 'Component/Cabecalho';
import LayoutDefault from 'Component/Layout';

import AsoVencendo from './AsoVencendo';
import Documentacao from './Documentacao';
import Experiencia from './Experiencia';
import FeriasVencendo from './FeriasVencendo';

const Default = (): React.ReactElement => {
  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Casos de atenção"
        descricao="Aqui você encontrara tudo que precisa de uma atenção sua"
      />
      <div className="row">
        <div className="col-md-12 mb-3">
          <Documentacao />
        </div>
        <div className="col-md-12 mb-3">
          <Experiencia />
        </div>
        <div className="col-md-6 mb-3">
          <FeriasVencendo />
        </div>
        <div className="col-md-6 mb-3">
          <AsoVencendo />
        </div>
      </div>
    </LayoutDefault>
  );
};

export default Default;
